import React, { useEffect, useState } from "react";
import Wrapper from "../../components/wrapper/Wrapper";
import ChatHeads from "./ChatHeads/ChatHeads";
import ChatList from "./ChatList/ChatList";
import { getSocket } from "../../socket/socket";
import { FaArrowLeft } from "react-icons/fa"; // Import back icon

const Chat = () => {
  const [chatsHeads, setChatsHeads] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [chatList, setChatList] = useState([]);

  useEffect(() => {
    const socket = getSocket();
    socket.on("fetchChatHeads", (chathead) => {
      if (chathead) {
        console.log("fetchChatHeads", chathead);
        setChatsHeads([chathead, ...chatsHeads]);
      }

      return () => {
        socket.off("fetchChatHeads"); // Remove listener
      };
    });
  }, [chatsHeads]);

  return (
    <Wrapper>
      {/* Header Section */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">Chat</h1>
        <p className="text-gray-500 text-sm">Communicate with users and provide support</p>
      </div>

      {/* Main Chat Container */}
      <div className="flex flex-col md:flex-row bg-white rounded-xl shadow-sm border border-gray-100 h-[80vh] overflow-hidden">
        {/* Chat Heads Sidebar */}
        <div
          className={`flex-shrink-0 h-[80vh] overflow-hidden ${
            selectedChat ? "hidden md:block" : "block"
          }`}
        >
          <ChatHeads
            setChatList={setChatList}
            chatsHeads={chatsHeads}
            setChatsHeads={setChatsHeads}
            setSelectedChat={setSelectedChat}
            selectedChat={selectedChat}
          />
        </div>
        
        {/* Chat Area */}
        <div
          className={`flex-grow w-full md:w-2/3 relative h-full ${
            selectedChat ? "block" : "hidden md:block"
          }`}
        >
          {/* Back Button for Mobile */}
          {selectedChat && (
            <button
              className="absolute top-4 left-4 z-10 flex items-center p-2 bg-white rounded-full shadow-md border border-gray-200 md:hidden hover:bg-gray-50 transition-colors"
              onClick={() => setSelectedChat(null)}
            >
              <FaArrowLeft className="text-lg text-gray-600" />
            </button>
          )}
          <ChatList
            chatList={chatList}
            setChatList={setChatList}
            chatsHeads={chatsHeads}
            setChatsHeads={setChatsHeads}
            selectedChat={selectedChat}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default Chat;
